import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;
// main.js
import jsCookie from 'js-cookie'
Vue.prototype.$cookie = jsCookie;  // 在页面里可直接用 this.$cookie 调用

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 将自动注册所有组件为全局组件
import dataV from '@jiaminghi/data-view'
Vue.use(dataV)

import { Message } from 'element-ui'
Vue.prototype.$message = Message

// 全局引入api接口方法
import api from './api/api.js'
Vue.prototype.$api = api
// Vue.use(ElementUI)
Vue.use(ElementUI, {
  size: 'medium'
})
Vue.config.productionTip = false

Vue.filter('times',function(val){
  const tIndex = val.indexOf('T')
  if (tIndex == -1) return val
  const timeArr = val.split('T')
  const time = `${timeArr[0]} ${timeArr[1]}`
  return time
})
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
}).$mount('#app')
